import FarmFaceViz from "../../react-component";

export default function App() {
  return (
      <FarmFaceViz />
  );
}
